module.exports = __webpack_public_path__ + "img/daxdcover_sample.f2838912.png";